import React from 'react'
import OffLine from '../off-line'

const OffLineDe = () => {
    return <OffLine languageCode="de" />
}

export default OffLineDe
